import { useEffect, useState } from 'react';

/*
 * Ricerca e filtri delle liste restano quando si esce dalla pagina e ci si rientra.
 * Si tengono in sessionStorage (la scheda del browser: chiusa quella, si riparte puliti),
 * con una chiave per pagina + lista + campo. Se lo storage non e' disponibile (navigazione
 * privata, dati bloccati) le liste funzionano comunque, solo senza memoria.
 */
const PREFIX = 'sid-list:';

export const listStateKey = (...parts) => `${PREFIX}${window.location.pathname}|${parts.join('|')}`;

export const readListState = (key) => {
	try {
		const saved = sessionStorage.getItem(key);
		return saved === null ? undefined : JSON.parse(saved);
	} catch (e) {
		return undefined;
	}
};

export const writeListState = (key, value) => {
	try {
		if (value === undefined || value === null || value === '') sessionStorage.removeItem(key);
		else sessionStorage.setItem(key, JSON.stringify(value));
	} catch (e) {
		// storage non disponibile: nessuna memoria, nessun errore
	}
};

/*
 * Per i filtri controllati dalla pagina (chip, tendine, periodo): al primo montaggio
 * ripristina il valore salvato chiamando onChange, poi salva ogni cambiamento.
 */
export const useRememberedFilter = (key, value, onChange) => {
	useEffect(() => {
		const saved = readListState(key);
		// Un valore salvato di un altro tipo (es. testo di quando il filtro era a scelta singola,
		// ora elenco) non si ripristina: si riparte dal valore iniziale della pagina.
		const stessoTipo = Array.isArray(saved) === Array.isArray(value) && typeof saved === typeof value;
		if (saved !== undefined && stessoTipo && JSON.stringify(saved) !== JSON.stringify(value)) onChange(saved);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [key]);

	useEffect(() => {
		writeListState(key, value);
	}, [key, value]);
};

/* useState che si ricorda il valore per la pagina corrente (es. l'oggetto filtri di una lista). */
export const useRememberedState = (name, initial) => {
	const key = listStateKey(name);
	const [value, setValue] = useState(() => {
		const saved = readListState(key);
		return saved === undefined ? initial : saved;
	});
	useEffect(() => {
		writeListState(key, value);
	}, [key, value]);
	return [value, setValue];
};
